import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { InsurerStrip } from "@/components/site/InsurerStrip";
import { ProductShowcase } from "@/components/site/ProductShowcase";
import { Tailored } from "@/components/site/Tailored";
import { BestOffer } from "@/components/site/BestOffer";
import { Included } from "@/components/site/Included";
import { Claims } from "@/components/site/Claims";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { StickyMobileCTA } from "@/components/site/StickyMobileCTA";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <InsurerStrip />
        <ProductShowcase />
        <Tailored />
        <BestOffer />
        <Included />
        <Claims />
        <Faq />
      </main>
      <Footer />
      <WhatsAppButton />
      <StickyMobileCTA />
    </div>
  );
}
